import { SegmentedControl } from '@jusbrasil-web/shared-segmented-control'

export type FrequencyToggleProps = {
  options: ReadonlyArray<string>
  currentFrequency: string
  onChangeFrequency: (frequency: string) => void
}

export function FrequencyToggle({
  options,
  currentFrequency,
  onChangeFrequency,
}: FrequencyToggleProps) {
  return (
    <SegmentedControl
      data-testid="toggle-frequency-segmented-control"
      value={currentFrequency}
      onValueChange={onChangeFrequency}
    >
      {options.map((frequency) => (
        <SegmentedControl.Item key={frequency} value={frequency}>
          {frequency}
        </SegmentedControl.Item>
      ))}
    </SegmentedControl>
  )
}
